import { render, staticRenderFns } from "./ScoreDetailDialog.vue?vue&type=template&id=c008965a"
import script from "./ScoreDetailDialog.vue?vue&type=script&lang=js"
export * from "./ScoreDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ScoreDetailDialog.vue?vue&type=style&index=0&id=c008965a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports